var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const prefix = "EXPERIMENT_CREATE";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const defaultReducerState = {
  workspaceId: "",
  managementGroup: "",
  templateName: "",
  experimentTemplates: getDefaultAsyncWrapperObj(),
  flightControl: getDefaultAsyncWrapperObj(),
  trafficFilters: getDefaultAsyncWrapperObj(),
  experimentPrototype: getDefaultAsyncWrapperObj(),
  experimentConfiguration: { Id: "" },
  createdExperimentId: getDefaultAsyncWrapperObj()
};
const storeManagmentGroupAndTemplateNameInfo = "storeManagementGroupAndTemplateName";
const loadExpTemplatesActionTypes = createActionTypes("LOAD_EXP_TEMPLATES");
const loadFlightControlActionTypes = createActionTypes("LOAD_FLIGHT_CONTROL");
const loadTrafficFiltersActionTypes = createActionTypes("LOAD_TRAFFIC_FILTERS");
const loadExperimentPrototypeActionTypes = createActionTypes("LOAD_EXPERIMENT_PROTOTYPE");
const createExperimentActionTypes = createActionTypes("CREATE_EXPERIMENT");
const storeManagementGroupAndTemplateName = (workspaceId, managementGroup, templateName) => {
  return {
    type: storeManagmentGroupAndTemplateNameInfo,
    payload: {
      workspaceId,
      managementGroup,
      templateName
    }
  };
};
const loadExpTemplates = (workspaceId, managementGroup) => {
  return {
    type: loadExpTemplatesActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingExpTemplates = (workspaceId, managementGroup) => {
  return {
    type: loadExpTemplatesActionTypes.LOADING,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadedExpTemplates = (workspaceId, managementGroup, experimentTemplates) => {
  return {
    type: loadExpTemplatesActionTypes.LOADED,
    payload: {
      workspaceId,
      managementGroup,
      experimentTemplates
    }
  };
};
const loadFlightControl = (workspaceId, managementGroup) => {
  return {
    type: loadFlightControlActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingFlightControl = (workspaceId, managementGroup) => {
  return {
    type: loadFlightControlActionTypes.LOADING,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadedFlightControl = (workspaceId, managementGroup, flightControl) => {
  return {
    type: loadFlightControlActionTypes.LOADED,
    payload: {
      workspaceId,
      managementGroup,
      flightControl
    }
  };
};
const loadTrafficFilters = (workspaceId, managementGroup) => {
  return {
    type: loadTrafficFiltersActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingTrafficFilters = (workspaceId, managementGroup) => {
  return {
    type: loadTrafficFiltersActionTypes.LOADING,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadedTrafficFilters = (workspaceId, managementGroup, trafficFilters) => {
  return {
    type: loadTrafficFiltersActionTypes.LOADED,
    payload: {
      workspaceId,
      managementGroup,
      trafficFilters
    }
  };
};
const loadExperimentPrototype = (workspaceId, managementGroup, templateName) => {
  return {
    type: loadExperimentPrototypeActionTypes.LOAD,
    payload: {
      workspaceId,
      managementGroup,
      templateName
    }
  };
};
const loadingExperimentPrototype = (workspaceId, managementGroup, templateName) => {
  return {
    type: loadExperimentPrototypeActionTypes.LOADING,
    payload: {
      workspaceId,
      managementGroup,
      templateName
    }
  };
};
const loadedExperimentPrototype = (workspaceId, managementGroup, experimentPrototype) => {
  return {
    type: loadExperimentPrototypeActionTypes.LOADED,
    payload: {
      workspaceId,
      managementGroup,
      experimentPrototype
    }
  };
};
const createExperiment = (templateName, experimentConfiguration) => {
  return {
    type: createExperimentActionTypes.LOAD,
    payload: {
      templateName,
      experimentConfiguration
    }
  };
};
const creatingExperiment = () => {
  return {
    type: createExperimentActionTypes.LOADING,
    payload: {}
  };
};
const createdExperiment = (createdExperimentId) => {
  return {
    type: createExperimentActionTypes.LOADED,
    payload: {
      createdExperimentId
    }
  };
};
const experimentCreateReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case storeManagmentGroupAndTemplateNameInfo:
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        workspaceId: action.payload.workspaceId,
        // @ts-ignore
        managementGroup: action.payload.managementGroup,
        // @ts-ignore
        templateName: action.payload.templateName
      });
    case loadExpTemplatesActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        experimentTemplates: __spreadProps(__spreadValues({}, state.experimentTemplates), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadFlightControlActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        flightControl: __spreadProps(__spreadValues({}, state.flightControl), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadTrafficFiltersActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        trafficFilters: __spreadProps(__spreadValues({}, state.trafficFilters), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadExperimentPrototypeActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        experimentPrototype: __spreadProps(__spreadValues({}, state.experimentPrototype), {
          status: AsyncRequestStatus.Pending
        })
      });
    case createExperimentActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        createdExperimentId: __spreadProps(__spreadValues({}, state.createdExperimentId), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadExpTemplatesActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        experimentTemplates: __spreadProps(__spreadValues({}, state.experimentTemplates), {
          // @ts-ignore
          data: action.payload.experimentTemplates.data,
          // @ts-ignore
          status: !!action.payload.experimentTemplates.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          // @ts-ignore
          error: action.payload.experimentTemplates.error
        })
      });
    case loadFlightControlActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        flightControl: __spreadProps(__spreadValues({}, state.flightControl), {
          // @ts-ignore
          data: action.payload.flightControl.data,
          // @ts-ignore
          status: !!action.payload.flightControl.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          // @ts-ignore
          error: action.payload.flightControl.error
        })
      });
    case loadTrafficFiltersActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        trafficFilters: __spreadProps(__spreadValues({}, state.trafficFilters), {
          // @ts-ignore
          data: action.payload.trafficFilters.data,
          // @ts-ignore
          status: !!action.payload.trafficFilters.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          // @ts-ignore
          error: action.payload.trafficFilters.error
        })
      });
    case loadExperimentPrototypeActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        experimentPrototype: __spreadProps(__spreadValues({}, state.experimentPrototype), {
          // @ts-ignore
          data: action.payload.experimentPrototype.data,
          // @ts-ignore
          status: !!action.payload.experimentPrototype.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          // @ts-ignore
          error: action.payload.experimentPrototype.error
        })
      });
    case createExperimentActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        createdExperimentId: action.payload.createdExperimentId
      });
    default:
      return state;
  }
};
export {
  createActionTypes,
  createExperiment,
  createExperimentActionTypes,
  createdExperiment,
  creatingExperiment,
  experimentCreateReducer as default,
  defaultReducerState,
  experimentCreateReducer,
  loadExpTemplates,
  loadExpTemplatesActionTypes,
  loadExperimentPrototype,
  loadExperimentPrototypeActionTypes,
  loadFlightControl,
  loadFlightControlActionTypes,
  loadTrafficFilters,
  loadTrafficFiltersActionTypes,
  loadedExpTemplates,
  loadedExperimentPrototype,
  loadedFlightControl,
  loadedTrafficFilters,
  loadingExpTemplates,
  loadingExperimentPrototype,
  loadingFlightControl,
  loadingTrafficFilters,
  storeManagementGroupAndTemplateName
};
//# sourceMappingURL=ExperimentCreateContainer.ducks.js.map
